import { DiagnosticFamilyModel, GenerationModel } from './server-identification/diagnostic-family.model';

export class FamilyGenerationPair {
    id: number;
    diagnosticFamily: DiagnosticFamilyModel;
    generation: GenerationModel;
}